module.exports = __webpack_public_path__ + "static/media/cerveja-me-mockup.aed50eb7.jpg";